export default __webpack_public_path__ + "static/apple-consultants-network-white-8be3524f92e1aae24f3237fd9a3bce89.png";